import React from 'react'
import HockeyJersey from './HockeyJersey'
import SoccerJersey from './SoccerJersey'
import BasketballJersey from './BasketballJersey'

const JerseyPatterns = {
  1: SoccerJersey,
  2: HockeyJersey,
  3: BasketballJersey,
  default: HockeyJersey,
}

/**
 * Jersey Pattern Component
 * Renders different jersey patterns based on sport type
 *
 * @param {string} pattern - Pattern type: 'hockey', 'soccer', 'default'
 * @param {string} color - Jersey color hex (default: '#DC1D1D')
 * @param {number} width - SVG width (default: 172)
 * @param {number} height - SVG height (default: 121)
 * @param {object} rest - Additional props passed to the pattern component
 *
 * @example
 * <JerseyPattern pattern="hockey" color="#DC1D1D" width={172} />
 * <JerseyPattern pattern="soccer" color="#0066CC" width={200} height={140} />
 */
export default function JerseyPattern(props) {
  const { pattern = 'default', ...rest } = props
  const PatternComponent = JerseyPatterns[pattern] || JerseyPatterns.default
  return <PatternComponent {...rest} />
}

export { HockeyJersey, SoccerJersey, BasketballJersey }
